import { EventEmitter, Injectable, Input } from "@angular/core";
import { ParticleCacheService } from "@core/services/particle-cache.service";
import { TimeZoneService } from "@core/services/time-zone.service";
import {
  TranslationSources,
  TranslationToolNames,
} from "@features/translation/models/translation.constants";
import { TranslationFormModel } from "@features/translation/models/translation.model";
import { TranslationConfig } from "@features/translation/translation-config";
import { Store, select } from "@ngrx/store";
import { PlatformCommand } from "@shared/commands/command-base";
import { IPlatformToolHandler } from "@shared/components/platform-tool/platform-tool-container/platform-tool-component";
import { InvalidateSubject } from "@shared/helpers/invalidate.subject";
import { DialogModel } from "@shared/models/dialog.model";
import { MagicLinkModel, TabModel } from "@shared/models/platform-tool-models";
import { TaxFormsInfo } from "@shared/models/tax-forms-type.model";
import { QueryProvider } from "@shared/queries/query-provider";
import { DialogService } from "@shared/services/dialog-service";
import { InvalidateSmartGridAction } from "@shared/store/actions/smart-grid.actions";
import { Dynamic_Grid_Data_Request_Parameters } from "@shared/store/actions/virtual-grid.actions";
import {
  ParticleState,
  getApplicationWithId,
} from "@shared/store/reducers/particle.reduer";
import { IQueryState } from "@shared/store/reducers/query.reducer";
import { Guid } from "guid-typescript";
import moment from "moment";
import { Subject } from "rxjs";
import { take, takeUntil } from "rxjs/operators";
import { TranslationService } from "../../translation/services/translation.service";
import { TaxFormsGridsInfo } from "../models/tax-forms.constants";
import {
  DateModel,
  TaxFormCountries,
  TaxFormSupportiveLanguage,
} from "../models/tax-forms.model";
import { TaxFormsState } from "../store/reducers/tax-forms.reducers";
import {
  getDirtyCountrySelectionState,
  getTaxFormsDateRange,
  getTaxFormsSelectedCountries,
} from "../store/selectors/tax-forms.selectors";
import {GridValueChangeEvent} from "@shared/models/common.models";
import {CommandService} from "@core/services/command.service";
import {FuseSplashScreenService} from "@barebone-fuse-services/splash-screen.service";
import {Router} from "@angular/router";
import {TaxFormsService} from "@features/tax-forms/services/tax-forms.service";
import {getQueryResponse} from "@shared/store/selectors/query.selector";
import {RootDynamicComponentHelper} from "@shared/helpers/root-dynamic-component-helper";

@Injectable({
  providedIn: "root",
})
export class PlatformToolItrceFormsHandler implements IPlatformToolHandler {
  @Input() taxFormsInfo: TaxFormsInfo = null;
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any>;
  taxformsSupportiveLanguage: TaxFormSupportiveLanguage[] = [];
  appUrl = "";

  filteredCountries: TaxFormCountries[] = [];
  selectedCountries: TaxFormCountries[] = [];
  unsubscribe$ = new Subject();
  supportiveLanguageQueryKey = "TaxFormsSupportiveLanguage";
  countries$: any;
  private dateRangeSelectSubscription: any;
  dateFilter: DateModel = null;
  sourceType = "Itrce-TaxForm";
  categoryCode: string;
  selectedCountryCode: string[];
  countryService: any;
  language$:any;
  smartConfig: any;
  dateRangeService: any;

  constructor(
    private dialogService: DialogService,
    private translationService: TranslationService,
    private particleStore: Store<ParticleState>,
    private taxFormsStore: Store<TaxFormsState>,
    private queryStore: Store<IQueryState>,
    private timeZoneService: TimeZoneService,
    private particleCacheService: ParticleCacheService,
    private commandService : CommandService,
    private fuseSplashScreenService : FuseSplashScreenService,
    private router : Router,
    private taxFormsService : TaxFormsService) {}

  executeCommand(command: PlatformCommand, callBack?: any) {
    switch (command.name) {
      case "SelectTaxFormCountryDialogCommand":
        this.subscribeToCountries();
        this.openCountryFilter();
        break;
      case "DateRangeDialogCommand":
        this.subscribeToDateRange();
        this.openDateFilter();
        break;
      default:
        this.executeCommandToApi(command, callBack);
        break;
    }
  }

  executeCommandWithHandler(command: PlatformCommand, callBack?: any) {
    console.log('Executing PlatformCommand : ', command.name);
    if (command.fieldValues['CommandHandler']) {
      const commandHandler = RootDynamicComponentHelper.getComponent(command.fieldValues['CommandHandler']);
      if (commandHandler) {
        commandHandler.executeCommand(command, this);
        return;
      }
    }
    this.executeCommand(command, this);
  }

  valueChanged($event: any) {
    console.log("[PlatformToolItrceFormsHandler] ValueChanged", $event);
    if ($event.action && $event.item) {
      this.handleGridActions($event);
      return;
    }
  }

  download(formId, categoryCode, formName, countryName) {
    //extra parameter added for Activity Tracking
    this.taxFormsService.downloadFormWithId(formId, categoryCode, formName, countryName);
  }

  handleGridActions($event: any) {
    console.log("[PlatformToolItrceFormsHandler] Handle Grid Actions", $event);
    const form = $event.item.cells['FormInfo'].value.form;
    const formName = form.name;
    const formId = form.id;
    const countryName = form.countryName;
    const countryCode = form.countryCode;
    const categoryCode = form.categoryCode;
    const taxYear = form.taxYear;
    const language = $event.item.cells['Language'].value
    const pairedForm = $event.item.cells['FormInfo'].value.pairedForm;
    const rightFormId = pairedForm?.id;
    const rightFormName = pairedForm?.name;
    const command = this.magicLinkModel.additionalCommands[$event.action.id];
    if (command) {
      command.fieldValues['FormId'] =  formId;
      command.fieldValues['FormName'] = formName;
      command.fieldValues['CountryName'] = countryName;
      command.fieldValues['CategoryCode'] = categoryCode;
      command.fieldValues['TaxYear'] = taxYear;
      command.fieldValues['CountryCode'] =  countryCode;
      command.fieldValues['FormLanguage'] = language;
      command.fieldValues['PairedForm'] = pairedForm;
      command.fieldValues['RightFormId'] = rightFormId;
      command.fieldValues['RightFormName'] = rightFormName;
      this.executeCommandWithHandler(command);
    } else {
      switch ($event.action.id) {
        case 'Download':
          this.download(formId, categoryCode, formName, countryName);
          break;
        default:
      }
    }
  }

  executeCommandToApi(command: PlatformCommand, callBack?: any) {
    const observer = this.commandService.executePlatformCommand(command);
    if (observer) {
      this.fuseSplashScreenService.show();
      observer.pipe(take(1)).subscribe(commandResponse => {
        this.fuseSplashScreenService.hide();
        if (commandResponse.fieldValues['RedirectUrl']) {
          this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
        }
      }, err => {
        this.fuseSplashScreenService.hide();
      });
    }
  }

  setSelectedTab(selectedTab: TabModel): void {
    if (this.selectedCountryCode && this.selectedCountryCode.length > 0) {
      selectedTab.tabData["CountryCodes"] = this.selectedCountryCode;
    }

    if (this.dateFilter) {
      selectedTab.tabData["StartDate"] = this.timeZoneService.getUTCDateWithZeroTimeOffset(this.dateFilter.fromDateValue);
      selectedTab.tabData["EndDate"] = this.timeZoneService.getUTCDateWithZeroTimeOffset(this.dateFilter.toDateValue);
    }
  }

  destroy(): void {
    // this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

 

  onBeforeLoad(): void {
    if (!this.taxFormsInfo) {
      // this is a reusable component
      this.taxFormsInfo = TaxFormsGridsInfo;
    }
    this.particleStore
      .pipe(select(getApplicationWithId, "ITCE"))
      .subscribe((app) => {
        if (app && app.HostUrl) {
          this.appUrl = app.HostUrl;
          console.log(this.appUrl);
        }
      });
    this.taxFormsStore
      .pipe(select(getDirtyCountrySelectionState), takeUntil(this.unsubscribe$))
      .subscribe((state) => {
        if (state === false) {
          QueryProvider.invokeQuery(
            this.queryStore,
            this.taxFormsInfo.queryKey,
            this.taxFormsInfo.queryProviderArg
          );
        }
      });
    this.countries$ = this.taxFormsStore.pipe(
      select(getTaxFormsSelectedCountries),
      take(2)
    );


    if (this.selectedCountries.length === 0) {
      this.subscribeToCountries();
    } else {
      this.changeCountryTitle();
    }

    this.dateRangeSelectSubscription = this.taxFormsStore.pipe(
      select(getTaxFormsDateRange),
      take(1)
    );

    if (this.dateFilter === null) {
      this.subscribeToDateRange();
    } else {
      this.changeDateTitle();
    }
  }

  subscribeToDateRange() {
    this.dateRangeService = this.dateRangeSelectSubscription.subscribe(
      (filter) => {
        if (filter) {
          this.dateFilter = new DateModel(filter);
          this.dateFilter.fromDateValue = this.timeZoneService.getDisplayDate(
            this.dateFilter.fromDate
          );
          this.dateFilter.toDateValue = this.timeZoneService.getDisplayDate(
            this.dateFilter.toDate
          );
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  subscribeToCountries() {
    this.countryService = this.countries$.subscribe(
      (countries) => {
        if (countries) {
          this.filteredCountries = Object.assign([], countries);
          this.selectedCountries = this.filteredCountries.filter(
            (country) => country.isChecked
          );
        }
      },
      (error) => {
        console.log(error);
      },
      () => {
        this.changeCountryTitle();
      }
    );
  }

  unSubscribeToCountries() {
    if (this.countryService) {
      this.countryService.unsubscribe();
    }
  }

  invalidateGrid() {
    if (this.filteredCountries && this.dateFilter) {
      this.updateGridConfig();
      this.invalidateItems();
      this.invalidateSubject.invalidate();
    }
  }

  updateGridConfig() {
    const newConfig = this.particleCacheService.getUserPreferenceGridSetting(
      Dynamic_Grid_Data_Request_Parameters,
      this.sourceType
    );

    const countries = this.getCountryCode(this.selectedCountries);

    if (countries) {
      newConfig["CountryCodes"] = countries;
    }
    if (this.dateFilter) {
      newConfig["StartDate"] = this.timeZoneService.getUTCDateWithZeroTimeOffset(this.dateFilter.fromDateValue);
      newConfig["EndDate"] = this.timeZoneService.getUTCDateWithZeroTimeOffset(this.dateFilter.toDateValue);
    }

    this.particleCacheService.saveUserPreferenceGridSetting(
      Dynamic_Grid_Data_Request_Parameters,
      this.sourceType,
      newConfig
    );
  }

  invalidateItems() {
    this.particleStore.dispatch(
      new InvalidateSmartGridAction(this.sourceType, true, true, true)
    );
  }

  openCountryFilter() {
    const dialogModel: DialogModel = DialogModel.create(
      "Countries",
      "FormToolbarCountrylistDialogComponent",
      { filteredCountries: this.filteredCountries },
      "700px",
      "700px"
    );
    dialogModel.okCaption = "Done";
    this.dialogService.showOkCancelDialog(dialogModel).subscribe((res) => {
      if (res.action === "OK") {
        this.unSubscribeToCountries();
      }
    });
  }

  openDateFilter() {
    const dialogModel: DialogModel = DialogModel.create(
      "Date Filter",
      "DateRangeDialogComponentComponent",
      { dateFilter: this.dateFilter }
    );
    dialogModel.okCaption = "Done";
    this.dialogService.showOkCancelDialog(dialogModel).subscribe((res) => {
      if (res.action === "OK") {
        this.changeDateTitle();
      }
    });
  }

  private changeDateTitle() {
    getTaxFormsDateRange.setResult(this.dateFilter);

    if (this.magicLinkModel.breadcrumbBar.items[0]?.commands[0]?.title) {
      this.magicLinkModel.breadcrumbBar.items[0].commands[0].title =
        this.getDisplayDate();
      this.invalidateGrid();
    }
  }

  private changeCountryTitle() {
    if (this.selectedCountries.length > 1) {
      this.magicLinkModel.breadcrumbBar.items[0].commands[1].title = this.selectedCountries.length + " countries";
    }
    else if (this.selectedCountries.length === 0) {
      this.magicLinkModel.breadcrumbBar.items[0].commands[1].title = "Select";
    }
    else if (this.selectedCountries.length === 1) {
      this.magicLinkModel.breadcrumbBar.items[0].commands[1].title = this.selectedCountries[0].name;
    }

    this.selectedCountryCode = this.getCountryCode(this.selectedCountries);
    this.invalidateGrid();
  }

  private getDisplayDate() {
    return (
      moment(this.dateFilter.fromDateValue).format("D MMMM YYYY") +
      " - " +
      moment(this.dateFilter.toDateValue).format("D MMMM YYYY")
    );
  }

  private getCountryCode(countryList: TaxFormCountries[]) {
    let countryCode: string[] = [];
    for (let i = 0; i < countryList.length; i++) {
      countryCode.push(countryList[i].code);
    }
    return countryCode;
  }
}
